import "./HotelRevenueManagementInGuwahati.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import RegionalMarketInsights from "./sections/RegionalMarketInsights";
import RevenueMetrics from "./sections/RevenueMetrics";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function HotelRevenueManagementInGuwahatiPage() {
  return <div>
      <Header />
      <Hero />
      <RegionalMarketInsights />
      <RevenueMetrics />
      <Contact />
      <Footer />
    </div>;
}